<template>
  <a-modal
    :visible="props.visible"
    :title="props.title"
    centered
    cancelText="Cancelar"
    :okText="okText"
    @cancel="handleCancel"
    @ok="handleOk"
    :confirm-loading="okLoading"
    :ok-button-props="{ disabled: disabledActions }"
  >
    <div>
      <p>Selecciona el rango de fechas en el que deseas descargar la data de tu chatbot.</p>
      <!-- Rango de fecha de creación -->
      <a-form layout="vertical" class="from-picker" ref="formRef" :rules="rules" :model="formState">
        <a-form-item class="form-item-picker" name="startDate" label="Fecha de inicio" required>
          <a-date-picker
            v-model:value="formState.startDate"
            valueFormat="YYYY-MM-DD"
            format="DD/MM/YYYY"
          />
        </a-form-item>

        <a-form-item class="form-item-picker" name="endDate" label="Fecha de fin" required>
          <a-date-picker
            v-model:value="formState.endDate"
            valueFormat="YYYY-MM-DD"
            format="DD/MM/YYYY"
          />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import dayjs from "dayjs";
import { stringToDate, dateToString } from "@/app/shared/utils/dates";
import { downloadFile } from "@/app/shared/utils/file";
import { message } from "ant-design-vue";
import { downloadReport } from "@/app/chatbots/services";

const props = defineProps({
  visible: {
    type: Boolean,
    require: true,
    default: false,
  },
  title: { type: String, require: true },
  onOk: {
    type: Function,
    require: true,
  },
  maxMonths: { type: Number, require: false, default: 0 },
  id: { type: Number, require: true },
});

const emits = defineEmits(["onClose"]);

const formRef = ref();
const okLoading = ref(false);
const disabledActions = ref(false);
const today = dayjs();
const oneMonthAgo = today.subtract(1, "month");
const formState = ref({
  startDate: oneMonthAgo.format('YYYY-MM-DD'),
  endDate: today.format('YYYY-MM-DD'),
  // endDate: null,
});

const rules = {
  startDate: [{ required: true, message: "Campo requerido" }],
  endDate: [
    { required: true, message: "Campo requerido" },
    {
      validator: (value: string) => {
        const startDate = stringToDate(formState.value.startDate);
        const valueDate = stringToDate(formState.value.endDate);
        if (!value) {
          return Promise.resolve();
        }
        if (startDate && valueDate && valueDate < startDate) {
          return Promise.reject("La fecha de fin debe ser mayor que la fecha de inicio");
        } else if (startDate && dayjs(startDate).add(31, "day").isBefore(dayjs(valueDate))) {
          return Promise.reject("Las fechas no deben tener más de un mes de diferencia");
        } else {
          return Promise.resolve();
        }
      },
    },
  ],
};

const endOpen = ref(false);
/**
 * @return {String} texto del boton principal
 */
const okText = computed(() => {
  return okLoading.value ? "Descargando" : "Descargar";
});

/**
 * Ejecuta la descarga
 */
const handleOk = async () => {
  console.log("handle ok download");
 
  formRef.value.validate().then(async () => {
    disabledActions.value = true;
    console.log("handle ok download --");
    okLoading.value = true;
    
    try {
      const response = await downloadReport(props.id, formState.value);

      downloadFile(
        response,
        `chatbot-${formState.value.startDate}-${formState.value.endDate}.xlsx`,
        { useResponseFileName: true }
      );
    } catch (error) {
      console.error(error);
      message.error("Ha ocurrido un error");
    }
    okLoading.value = false;
    disabledActions.value = false;
    handleCancel();
  });
};

// const disabledStartDate = (startValue: any) => {
//   const endValue1 = endValue;
//   if (!startValue || !endValue1) {
//     return false;
//   }
//   return startValue.valueOf() > endValue1.valueOf();
// };

// const disabledEndDate = (endValue: any) => {
//   const startValue1 = startValue;
//   if (!endValue || !startValue1) {
//     return false;
//   }
//   return startValue1.valueOf() >= endValue.valueOf();
// };

// const handleStartOpenChange = (open: any) => {
//   if (!open) {
//     endOpen.value = true;
//   }
// };
// const handleEndOpenChange = (open: any) => {
//   endOpen.value = open;
// };

/**
 * Cancela la accion
 */
const handleCancel = () => {
  emits("onClose");
  formRef.value.resetFields();
};
</script>

<style lang="sass" scoped>
.form
  &__description
    margin: 12px auto 20px auto
    text-align: center
.container__date
  display: flex
  justify-content: center

.from-picker
  display: flex
  margin-top: 20px
  .ant-form-item
    width: 50%
    margin-right: 10px
  .ant-picker
    width: 100%
</style>
